import useFormValidation from "hooks/useFormValidation";
import { Label } from "layout/typography/Label";
import { Dropdown } from "primereact/dropdown";
import { Controller, useFormContext } from "react-hook-form";
import { IDirectPayLinkPublicConfig } from "types/DirectPayLink.d";

interface IProviderNameProps {
  linkConfig?: IDirectPayLinkPublicConfig | null;
}

export function ProviderName({ linkConfig }: IProviderNameProps) {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const { getFormErrorMessage } = useFormValidation();

  // Hide provider selection if link config says so or no providers available
  const showProviderName = linkConfig?.showProviderName ?? false;
  const providers = linkConfig?.providers || [];

  // Only show for public links when enabled and providers are available
  if (!showProviderName || providers.length === 0) {
    return null;
  }

  // Map providers to dropdown options
  const providerOptions = providers.map((provider) => ({
    label: provider.name,
    value: provider.id,
  }));

  return (
    <div className="field flex flex-column col-12 md:col-6">
      <Label htmlFor="providerId">Provider</Label>

      <Controller
        name="providerId"
        control={control}
        rules={{ required: "Please select a provider" }}
        render={({ field: { onChange, value } }) => (
          <>
            <Dropdown
              id="providerId"
              value={value}
              options={providerOptions}
              onChange={(e) => onChange(e.value)}
              placeholder="Select a provider"
              className="w-full"
            />
            {getFormErrorMessage("providerId", errors)}
          </>
        )}
      />
    </div>
  );
}
